import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";
import { initialSeoState } from "../../models/seoModel";

export const fetchSeo = createAsyncThunk(
  "seo/fetchSeo",
  async (_, thunkAPI) => {
    try {
      const response = await apiService("/Seo/GetAll");
      if (response.isSuccess) {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response.message || "Hata oluştu");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const seoSlice = createSlice({
  name: "seo",
  initialState: initialSeoState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSeo.fulfilled, (state, action) => {
        state.loading = false;
        state.dataSeo = action.payload;
      })
      .addCase(fetchSeo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default seoSlice.reducer;
